import React from "react";
import PropTypes from "prop-types";
import { Dropdown } from "@shared/v1";
import Error from "@shared/Error";
import IconButton from "@shared/v2/IconButton";
import { XmarkLargeSolidV6 } from "@shared/v2/Icomoon";
import TextButton from "@shared/v2/TextButton";
import Button from "@shared/v2/Button";
import Modal from "@shared/v2/Modal";

const defaultAgent = {
  label: "",
  value: "",
  id: "",
  name: "",
  isNotValid: false,
  errMsg: "",
};

class AddAgentModal extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      selectedAgents: [defaultAgent],
    };
  }

  onHideAgent = () => {
    const { setIsOpenAddAgentModal } = this.props;
    setIsOpenAddAgentModal(false);
  };

  addAnother = () => {
    this.setState(({ selectedAgents }) => ({ selectedAgents: [...selectedAgents, defaultAgent] }));
  };

  saveAgentData = () => {
    const { listingData, setFinancialData, setIsOpenAddAgentModal } = this.props;
    const { selectedAgents } = this.state;
    const filteredAgents = selectedAgents.filter((agent) => agent.id !== "");
    if (selectedAgents.length !== filteredAgents.length) {
      this.setState({
        isNotValid: true,
        errMsg: "Please select an agent",
      });
    } else {
      filteredAgents.forEach((agentObj) => {
        const customTeamMemberExpenses = agentObj.custom_team_member_expenses_attributes.map((expense) => {
          const expenseTypeName = Object.keys(listingData.agent_expense_types).find(
            (key) => listingData.agent_expense_types[key] === expense.agent_expense_type_id,
          );
          return { ...expense, name: expense.name !== null ? expense.name : expenseTypeName };
        });

        listingData.team_member_incomes.incomes.push({
          user_id: agentObj.id,
          name: agentObj.name,
          custom_team_member_expenses_attributes: customTeamMemberExpenses,
          agent_gci: 0,
          agent_gci_units: 0,
          agent_gci_percentage: false,
          gross_income: 0,
          brokerage_split_amount: 0,
          brokerage_split_line_total: 0,
          brokerage_split: agentObj.brokerage_split,
          brokerage_split_percentage: agentObj.brokerage_split_percentage,
          royalty_amount: 0,
          royalty_line_total: 0,
          royalty: agentObj.royalty,
          royalty_percentage: agentObj.royalty_percentage,
          net_income: 0,
        });
      });
      setFinancialData(listingData);
      setIsOpenAddAgentModal(false);
    }
  };

  addAgentClassName = () => {
    const { selectedAgents } = this.state;
    const foundObj = selectedAgents.find((obj) => obj.name === "");
    if (foundObj) {
      return "add_agent_link disabled";
    }
    return "add_agent_link";
  };

  removeAgent = (index) => {
    const { selectedAgents } = this.state;
    selectedAgents.splice(index, 1);
    this.setState({ selectedAgents });
  };

  render() {
    const { isOpenAddAgentModal, agentList } = this.props;
    const { errMsg, isNotValid, selectedAgents } = this.state;

    return (
      <Modal
        show={isOpenAddAgentModal}
        onHide={this.onHideAgent}
        dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
        contentClassName="tw-max-w-[640px] tw-max-h-[90vh] tw-w-full tw-flex tw-flex-col tw-gap-[32px]"
      >
        <Modal.Header
          description="This is unique to this transaction and will not be repeated"
          title="Add Agent To Transaction Financials"
          closeButton
        />

        <Modal.Body className="tw-flex tw-flex-col tw-gap-[12px]">
          {isNotValid && <Error errorMessage={errMsg} />}

          {selectedAgents.map((agent, i) => (
            <div className="tw-flex tw-gap-[4px]">
              <div className="tw-flex-1">
                <Dropdown
                  isSearchable
                  isClearable={false}
                  name={`agentDrp${i}`}
                  onChange={(e) => {
                    if (selectedAgents.findIndex((obj) => obj.id === e.id) > -1) {
                      this.setState({
                        errMsg: "Cannot add team member more than once.",
                        isNotValid: true,
                      });
                    } else {
                      selectedAgents[i] = e;
                      this.setState({ selectedAgents });
                    }
                  }}
                  value={agent.value || null}
                  options={agentList}
                />
              </div>

              {i > 0 && (
                <IconButton schema="transparent" onClick={() => this.removeAgent(i)}>
                  <XmarkLargeSolidV6 />
                </IconButton>
              )}
            </div>
          ))}

          <div>
            <TextButton schema="tertiary" onClick={this.addAnother}>
              Add Another Agent
            </TextButton>
          </div>
        </Modal.Body>
        <Modal.Footer className="tw-flex tw-justify-between tw-gap-[16px]">
          <Button size="medium" schema="tertiary" onClick={this.onHideAgent}>
            Cancel
          </Button>
          <Button size="medium" onClick={this.saveAgentData}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

AddAgentModal.propTypes = {
  isOpenAddAgentModal: PropTypes.bool.isRequired,
  setIsOpenAddAgentModal: PropTypes.func.isRequired,
  listingData: PropTypes.shape().isRequired,
  setFinancialData: PropTypes.func.isRequired,
  agentList: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export default AddAgentModal;
